module.exports = __webpack_public_path__ + "static/img/S06.cd00f51.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/order/hongbao/S06.jpg
// module id = IJQ8
// module chunks = 9